import { useNavigate } from "react-router-dom";
import Footer from "../Footer";
import Header from "../Header";

const AddPostMessagePage = () => {
    let navigate = useNavigate();
    return (
        <>
            <Header />
            <div className="thanks-page">
                <h2
                    style={{
                        background: "linear-gradient(90deg, #ED9C17 12.5%, #CD495B 100%)",
                        WebkitBackgroundClip: "text",
                        color: "transparent",
                    }}
                >
                    Thank you for adding post in Flying Help!
                </h2>

                <div className="thanks-page-div">
                    <p>
                        You need to wait to see this post in the live feed until it is approved by our team.
                    </p>
                </div>
                <div className="thanks-page-div" style={{ margin: '0px 0 20px 0' }}>
                    <button type="button" className="donate-btn" onClick={() => {
                        navigate('/posts')
                    }}>Back to live posts</button>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default AddPostMessagePage;
